import _ from "lodash";
import {Attribute} from "./Attribute";
import {User} from "@/entity/User";

export class Card {
  constructor(props = {}) {
    this.id = props.id
    this.name = props.name || ''
    this.canExchange = props.canExchange || false
    this.data = props.data || ''
    const attribute = props.attributes
    if (typeof attribute === "string" || attribute instanceof String) {
      this.attributes = _.sortBy(JSON.parse(props.attributes || "[]").map((a) => { return new Attribute(a) }), 'order')
    } else {
      this.attributes = props.attributes
    }
    this.tmpFileId = props.tmpFileId
    this.backSideTmpFileId = props.backSideTmpFileId
    this.backSideImageFile = props.backSideImageFile
    this.mime = props.mime
    this.user = new User(props.user || {})
    this.isPublic = props.isPublic || false
  }

  canUpload = () => {
    return this.name && this.tmpFileId
  }

  export = () => {
    return {
      id: this.id,
      name: this.name,
      data: this.data,
      tmpFileId: this.tmpFileId,
      backSideTmpFileId: this.backSideTmpFileId,
      attributes: JSON.stringify(this.attributes),
      isPublic: this.isPublic
    }
  }
  exportForAdd = () => {
    return {
      name: this.name,
      tmpFileId: this.tmpFileId,
      backSideTmpFileId: this.backSideTmpFileId,
      isPublic: this.isPublic || false,
    }
  }
}
